import NL_TRANSLATIONS from "./nl.json";
import FR_TRANSLATIONS from "./fr.json";
import DE_TRANSLATIONS from "./de.json";

const TRANSLATIONS = {
  nl: NL_TRANSLATIONS,
  fr: FR_TRANSLATIONS,
  de: DE_TRANSLATIONS,
};

export const DEFAULT_LANGUAGE = "nl";

/**
 * Resolve the translation
 *
 * @param {string | Array<string>} key_or_keys - The key to translate, or an array of keys
 * @param {Record<string, string>} interpolations - Values to be filled in the translation
 * @param {string} language - The language to translate to
 * @returns string
 */
export default function translate(
  key_or_keys,
  interpolations = {},
  language = DEFAULT_LANGUAGE,
) {
  const keys = Array.isArray(key_or_keys)
    ? key_or_keys
    : key_or_keys.split(".");
  let translation = keys.reduce((scope, key) => {
    if (scope) return scope[key];
  }, TRANSLATIONS[language]);

  if (translation === undefined) {
    // This should only happen during development
    // eslint-disable-next-line no-console
    console.error(`Translation ${keys.join(".")} could not be found`);
  } else if (typeof translation === "string") {
    Object.entries(interpolations).forEach(
      ([key, value]) =>
        (translation = translation.replaceAll(`{{${key}}}`, value)),
    );
  }

  return translation;
}

export function translatedPropertyFromKey(translation_key, interpolations) {
  return Object.keys(TRANSLATIONS).reduce((acc, locale) => {
    return Object.assign(acc, {
      [locale]: translate(translation_key, interpolations, locale),
    });
  }, {});
}
